import PropTypes from "prop-types";

import { useSelector } from "react-redux";

function TableCellWithOuterSeparator({ value = "NA", cellType = "td", styles = {}, mainProps = {}, showSeperator = true, testLabel = null, disableColor = false }) {
    const { main: mainStyles = {}, wrapper: wrapperStyles = {}, value: valueStyles = {} } = styles;

    const Component = cellType === "th" ? "th" : "td";
    const isHeader = cellType === "th";

    const productCategoryData = useSelector((state) => state.settingsStore.productCategory);

    const isHairCare = process.env?.REACT_APP_HAIR_CARE?.toLowerCase() === productCategoryData?.label?.toLowerCase();
    const isSkinCare = process.env?.REACT_APP_SKIN_CARE?.toLowerCase() === productCategoryData?.label?.toLowerCase();
    const isBeautyAndWellbeing = Boolean(isHairCare || isSkinCare);

    const separatorClassForHairSkin = isHeader
        ? "table-seperator-col table-seperator-head-height table-seperator-col-hair-skin"
        : "table-seperator-grey table-seperator-row-height table-seperator-grey-hair-skin";

    const separatorClassDefault = isHeader
        ? "table-seperator-col table-seperator-head-height"
        : "table-seperator-grey table-seperator-row-height";

    const separatorClass = isBeautyAndWellbeing ? separatorClassForHairSkin : separatorClassDefault;

    const cellClass = isHeader ? "table-head-cell" : "table-body-cell";

    return (
        <Component
            {...mainProps}
            style={mainStyles}
            scope={isHeader ? "col" : undefined}
        >
            <div
                style={{
                    display: "flex",
                    alignItems: "center",
                    height: "100%",
                    ...wrapperStyles,
                }}
            >
                {showSeperator && <div className={separatorClass} />}
                <div
                    className={cellClass}
                    style={{
                        display: "flex",
                        alignItems: "center",
                        textAlign: isHeader ? undefined : "center",
                        // whiteSpace: cellType !== "th" ? "nowrap" : "",
                        ...valueStyles,
                    }}
                >
                    {value}{" "}
                    {/* Only for skin & hair care */}
                    {isBeautyAndWellbeing && testLabel !== undefined && testLabel !== null && testLabel !== "" ? (
                        <span style={{ fontWeight: 700 }}>
                            &nbsp;&nbsp;
                            {String(testLabel)
                                .trim()
                                .split("")
                                .map((ch, idx) => {
                                    const upper = String(ch).toUpperCase();
                                    const colorMap = {
                                        A: "#A754FF",
                                        B: "#FF8000",
                                        C: "#0084FF",
                                    };

                                    if (!colorMap[upper] || disableColor) return <span key={`${upper}-${idx}`}>{ch}</span>;

                                    return (
                                        <span key={`${upper}-${idx}`}
                                            style={{ color: colorMap[upper], fontWeight: 700 }}>
                                            {ch}
                                        </span>
                                    );
                                })}
                        </span>
                    ) : (
                        <span style={{ fontWeight: 700 }}>&nbsp;&nbsp;{testLabel}</span>
                    )}
                </div>
            </div>
        </Component>
    );
}

TableCellWithOuterSeparator.propTypes = {
    value: PropTypes.node,
    testLabel: PropTypes.node,
    styles: PropTypes.shape({
        main: PropTypes.object,
        wrapper: PropTypes.object,
        value: PropTypes.object,
    }),
    mainProps: PropTypes.object,
    cellType: PropTypes.oneOf(["td", "th"]),
    showSeperator: PropTypes.bool,
    disableColor: PropTypes.bool,
};

export default TableCellWithOuterSeparator;